import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/agent-chats")({
  component: lazyRouteComponent(() => import("./-pages/admin.agent-chats")),
  head: () => ({
    meta: [
      { title: "Agent Chats · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
